import { GetterTree, Getter } from "vuex";
import { VideoReportingState } from "./types";
import { RootState } from "../types";

export const getters: GetterTree<VideoReportingState, RootState> = {
	getMaxCamerasPref: state => state.videoReportingPrefs.maxCameras,
	getMaxDurationPref: state => state.videoReportingPrefs.maxDuration,
	getMaxDistancePref: state => state.videoReportingPrefs.maxDistance,
	getCurrentReportEventId: state => state.currentReport.eventId,
	getCurrentReportId: state => state.currentReport.videoReportId,
	getReviewsComplete: state => state.currentReport.reviewsComplete,
	getVideoReportingState: state => state.videoReportingState
};
